import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'gridActionToString',
})
export class GridActionToStringPipe implements PipeTransform {
  transform(value: any): string {
    return value.toString();
  }
}
